    import React from 'react';

import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';

const Table = (props) => {
    return (
        <table className="table table-striped">
            <TableHeader
                functions={props.functions}
                column={props.column}
                columnIndex={props.columnIndex}
                orderColumn={props.orderColumn}
                setAllCheckbox={props.setAllCheckbox}
                allCheckboxFilter={props.allCheckboxFilter}
                currentUser={props.currentUser}/>

            <TableBody
                functions={props.functions}
                currentUser={props.currentUser}
                usuariosFiltrados={props.usuariosFiltrados}
                setCheckbox={props.setCheckbox}
                perfilId={props.perfilId}
                setUserState={props.setUserState} />
        </table>
    );
}

export default Table 